import { BeneficiaryFilters } from '@repo/shared/dtos/beneficiary'
import { StructuredDataSchema } from '@repo/shared/dtos/structured-data'

import FilterItem from './FilterItem'

export function ReadonlyFilterList({
  filters,
  schema,
}: {
  filters: BeneficiaryFilters
  schema: StructuredDataSchema
}) {
  const filtersWithSchema = filters
    .map((filter) => {
      const schemaItem = schema.find((item) => item.id === filter.key)
      if (!schemaItem) return null
      return { filter, schemaItem }
    })
    .filter((item) => item !== null)

  return (
    <div className="flex flex-row gap-2">
      {filtersWithSchema.map(({ filter, schemaItem }) => (
        <div className="shrink-0" key={filter.key}>
          <FilterItem filter={filter} schemaItem={schemaItem} readonly={true} />
        </div>
      ))}
    </div>
  )
}
